import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslations } from '@vp/om-translations';
import { FlexBox, Typography } from '@vp/swan';
import { TaxAwarePriceRow } from '@vp/component-library';
import { get } from 'lodash';
import {
  BASE_PRICE_NAME,
  DISPLAY_NAME,
  DISPLAY_VALUE,
  NAME,
} from '../../../constants/itemAccessors';
import useSiteData from '../../../hooks/useSiteData';
import { OrderDetailsContext } from '../../contexts/OrderDetailsContext';
import { currencyLocaleFormatter } from '../../../util/currencyFormatter';

const PricedItemOption = ({ option }) => {
  const { fractionDigits, currency } = useContext(OrderDetailsContext);
  const optionDisplayKey = get(option, DISPLAY_NAME);
  const optionDisplayValue = get(option, DISPLAY_VALUE);
  const optionName = get(option, NAME);

  // if present favor localized display values, else fallback to pricing component name
  const optionDisplayName =
    optionDisplayKey && optionDisplayValue
      ? `${optionDisplayKey}: ${optionDisplayValue}`
      : optionName;

  const [lineItemMessages] = useTranslations(['lineItemMessages']);
  const displayName =
    optionName === BASE_PRICE_NAME
      ? lineItemMessages.basePriceField
      : optionDisplayName;
  const { locale } = useSiteData();

  return (
    <FlexBox justifyContent="space-between" my={2}>
      <Typography textColor="subtle">{displayName}</Typography>
      <Typography fontWeight="bold">
        <TaxAwarePriceRow
          fractionDigits={fractionDigits}
          listCents={option.listCents}
          discountedCents={option.discountedCents}
          currencyCode={currency}
          locale={currencyLocaleFormatter(locale)}
        />
      </Typography>
    </FlexBox>
  );
};

PricedItemOption.propTypes = {
  option: PropTypes.object,
};

export default PricedItemOption;
